"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prefixer_1 = __importDefault(require("./prefixer"));
const value_to_string_1 = __importDefault(require("./value-to-string"));
const get_class_name_1 = __importDefault(require("./get-class-name"));
/**
 * Generates the class name and styles.
 */
function getCss(propertyInfo, value) {
    let rules;
    // Protect against unexpected values
    const valueType = typeof value;
    if (valueType !== 'string' && valueType !== 'number') {
        if (process.env.NODE_ENV !== 'production') {
            const name = propertyInfo.jsName;
            const encodedValue = JSON.stringify(value);
            console.error(`📦 ui-box: property “${name}” was passed invalid value “${encodedValue}”. Only numbers and strings are supported.`);
        }
        return null;
    }
    const valueString = value_to_string_1.default(value, propertyInfo.defaultUnit);
    const className = get_class_name_1.default(propertyInfo, valueString);
    // Avoid running the prefixer when possible because it's slow
    if (propertyInfo.isPrefixed) {
        rules = prefixer_1.default(propertyInfo.jsName || '', valueString);
    }
    else {
        rules = [{ property: propertyInfo.cssName || '', value: valueString }];
    }
    let styles;
    if (process.env.NODE_ENV === 'production') {
        const rulesString = rules
            .map(rule => `${rule.property}:${rule.value}`)
            .join(';');
        styles = `.${className}{${rulesString}}`;
    }
    else {
        const rulesString = rules
            .map(rule => `  ${rule.property}: ${rule.value};`)
            .join('\n');
        styles = `
.${className} {
${rulesString}
}`;
    }
    return { className, styles };
}
exports.default = getCss;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWNzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXQtY3NzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsMERBQXlDO0FBQ3pDLHdFQUE2QztBQUM3QyxzRUFBMkQ7QUFHM0Q7O0dBRUc7QUFDSCxTQUF3QixNQUFNLENBQUMsWUFBMEIsRUFBRSxLQUFzQjtJQUMvRSxJQUFJLEtBQWEsQ0FBQTtJQUVqQixvQ0FBb0M7SUFDcEMsTUFBTSxTQUFTLEdBQUcsT0FBTyxLQUFLLENBQUE7SUFDOUIsSUFBSSxTQUFTLEtBQUssUUFBUSxJQUFJLFNBQVMsS0FBSyxRQUFRLEVBQUU7UUFDcEQsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLEVBQUU7WUFDekMsTUFBTSxJQUFJLEdBQUcsWUFBWSxDQUFDLE1BQU0sQ0FBQTtZQUNoQyxNQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFBO1lBQzFDLE9BQU8sQ0FBQyxLQUFLLENBQ1gsd0JBQXdCLElBQUksK0JBQStCLFlBQVksNENBQTRDLENBQ3BILENBQUE7U0FDRjtRQUVELE9BQU8sSUFBSSxDQUFBO0tBQ1o7SUFFRCxNQUFNLFdBQVcsR0FBRyx5QkFBYSxDQUFDLEtBQUssRUFBRSxZQUFZLENBQUMsV0FBVyxDQUFDLENBQUE7SUFDbEUsTUFBTSxTQUFTLEdBQUcsd0JBQVksQ0FBQyxZQUFZLEVBQUUsV0FBVyxDQUFDLENBQUE7SUFFekQsNkRBQTZEO0lBQzdELElBQUksWUFBWSxDQUFDLFVBQVUsRUFBRTtRQUMzQixLQUFLLEdBQUcsa0JBQVEsQ0FBQyxZQUFZLENBQUMsTUFBTSxJQUFJLEVBQUUsRUFBRSxXQUFXLENBQUMsQ0FBQTtLQUN6RDtTQUFNO1FBQ0wsS0FBSyxHQUFHLENBQUMsRUFBQyxRQUFRLEVBQUUsWUFBWSxDQUFDLE9BQU8sSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBQyxDQUFDLENBQUE7S0FDckU7SUFFRCxJQUFJLE1BQWMsQ0FBQTtJQUNsQixJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLFlBQVksRUFBRTtRQUN6QyxNQUFNLFdBQVcsR0FBRyxLQUFLO2FBQ3RCLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLFFBQVEsSUFBSSxJQUFJLENBQUMsS0FBSyxFQUFFLENBQUM7YUFDN0MsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFBO1FBQ1osTUFBTSxHQUFHLElBQUksU0FBUyxJQUFJLFdBQVcsR0FBRyxDQUFBO0tBQ3pDO1NBQU07UUFDTCxNQUFNLFdBQVcsR0FBRyxLQUFLO2FBQ3RCLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEtBQUssSUFBSSxDQUFDLFFBQVEsS0FBSyxJQUFJLENBQUMsS0FBSyxHQUFHLENBQUM7YUFDakQsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ2IsTUFBTSxHQUFHO0dBQ1YsU0FBUztFQUNWLFdBQVc7RUFDWCxDQUFBO0tBQ0M7SUFFRCxPQUFPLEVBQUMsU0FBUyxFQUFFLE1BQU0sRUFBQyxDQUFBO0FBQzVCLENBQUM7QUE1Q0QseUJBNENDIn0=